import React from "react";

const TopAuthor = ({ articles }) => {
  return (
    <ol type="1" className="top-articles">
      <h1> Top 5 Blog Contributor</h1>
      {articles.map((data, idx) => {
        const { author, numberArticle } = data;
        return (
          <li key={author.id}>
            <a href={`/articles/${author.name}`}>
              <h2>{author.name} </h2>
            </a>
            <span>Authored {numberArticle} 📖 article!</span>
          </li>
        );
      })}
    </ol>
  );
};

export default TopAuthor;
